import controller from './card-delete-success-dialog.controller';

export default {
  controller,
  template: require('./card-delete-success-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/card-delete-success-dialog/card-delete-success-dialog.component.ts